var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('vue-slider',{model:{value:(_vm.contentZoom),callback:function ($$v) {_vm.contentZoom=$$v},expression:"contentZoom"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }